import {
  Box,
  Button,
  Checkbox,
  Chip,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon } from '@iconify/react';
import { useSnackbar } from 'notistack';
import MotionWrapper from '../../../../../components/MotionWrapper';
import Loader3D from '../../../../../components/Loader/Loader3D';
import useResponsive from '../../../../../Hooks/useResponsive';
import NoDataFound from '../../../../../components/NodataIndication/NoDataFound';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { CART_AED_TO_INR_VALUE } from '../../../../../utils/constants/GlobalStaticData';
const Options = ({
  clearSetSelectedSessionFee,
  item,
  handleInputChange,
  selectedSessionFee,
  setOpen,
  open,
  currecyType,
  setCurrecyType,
  selected,
  setSelected,
  update,
}) => {
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');
  const { enqueueSnackbar } = useSnackbar();

  const [tblHead, setTblHead] = useState([]);

  const { courseFeeOption, sessionPrize, loading, optionsLoading } = useSelector((state) => state.general);

  const DicoutedAedInr = () => {
    const data = courseFeeOption.find((item) => item.id === selected);
    if (!data) return null;
    return (
      <Chip
        size="small"
        variant="outlined"
        color="primary"
        label={`AED converted INR : ${
          data?.discount === 0
            ? selectedSessionFee.priceAed * CART_AED_TO_INR_VALUE
            : parseInt(
                (selectedSessionFee.priceAed - (selectedSessionFee.priceAed * data.discount) / 100) *
                  CART_AED_TO_INR_VALUE
              )
        }`}
      />
    );
  };

  useEffect(() => {
    if (item) {
      setSelected(item.selectedOption);
      setCurrecyType(item.selectedCurrency ? parseInt(item.selectedCurrency) : 1);
    }
  }, [item, open]);
  const getObjectWithMostTerms = (data) => {
    return data.reduce((maxObj, currentObj) => {
      const currentTerms = Object.keys(currentObj).filter((key) => key.startsWith('term')).length;
      const maxTerms = Object.keys(maxObj).filter((key) => key.startsWith('term')).length;

      return currentTerms > maxTerms ? currentObj : maxObj;
    });
  };
  useEffect(() => {
    if (courseFeeOption?.length > 0) {
      // ----------------------------------------------------------
      const HeaderData = getObjectWithMostTerms(courseFeeOption);
      // ------------------------------------------------------------

      const mappedArray = Object.entries(HeaderData).map(([key, value]) => ({
        keyName: key,
        value: value,
      }));
      setTblHead(mappedArray);
    }
  }, [courseFeeOption]);
  const handleClick = (e, row) => {
    if (selected) {
      if (row.id === selected) {
        setSelected('');
      } else {
        setSelected(row.id);
      }
    } else {
      setSelected(row.id);
    }
  };
  const handleChange = useCallback(
    (event) => {
      setCurrecyType(event.target.value);
    },
    [setCurrecyType, item.id]
  );

  const handleConfirm = () => {
    if (item.selectedCurrency == currecyType && item.selectedOption == selected) {
      enqueueSnackbar('Option already selected...!', {
        variant: 'error',
      });
    } else {
      if (selected) {
        const data = courseFeeOption.find((item) => item.id === selected);

        const mrp = {
          target: {
            value:
              currecyType == 1
                ? selectedSessionFee.price
                : currecyType == 2
                ? selectedSessionFee.priceAed
                : currecyType == 3
                ? selectedSessionFee.convertedInr
                : '',
          },
        };
        const paidamt = {
          target: {
            value: update && item.admissionFee == 0 ? data.term1 : data.term1 + item.admissionFee,
          },
        };
        const courseOptionId = { target: { value: selected } };

        const dis = {
          target: {
            value:
              currecyType == 1
                ? (selectedSessionFee.price * data.discount) / 100
                : currecyType == 2
                ? (selectedSessionFee.priceAed * data.discount) / 100
                : currecyType == 3
                ? // ? Math.round(
                  //     (selectedSessionFee.convertedInr * data.discount) / 100
                  //   )
                  data.discountAmt
                : '',
          },
        };
        const disZero = {
          target: { value: 0 },
        };
        const disUpdate = {
          target: {
            value:
              currecyType == 1 && item.admissionFee !== 0 && data.discount !== 0
                ? (selectedSessionFee.price * data.discount) / 100 + item.admissionFee
                : currecyType == 2 && item.admissionFee !== 0 && data.discount !== 0
                ? (selectedSessionFee.priceAed * data.discount) / 100 + item.admissionFee
                : currecyType == 1 && item.admissionFee == 0 && data.discount !== 0
                ? (selectedSessionFee.price * data.discount) / 100
                : currecyType == 2 && item.admissionFee == 0 && data.discount !== 0
                ? (selectedSessionFee.priceAed * data.discount) / 100
                : currecyType == 3 && item.admissionFee !== 0 && data.discount !== 0
                ? //  (selectedSessionFee.convertedInr * data.discount) / 100
                  data.discountAmt + item.admissionFee
                : currecyType == 3 && item.admissionFee == 0 && data.discount !== 0
                ? // (selectedSessionFee.convertedInr * data.discount) / 100
                  data.discountAmt
                : 0,

            // currecyType == 2
            // ? (selectedSessionFee.price * data.discount) / 100
            // : "",
          },
        };

        const discount = {
          target: {
            value:
              data.discount == 0
                ? '0'
                : currecyType == 1
                ? (selectedSessionFee.price * data.discount) / 100 + update && item.admissionFee == 0
                  ? 0
                  : item.admissionFee
                : currecyType == 2
                ? (selectedSessionFee.priceAed * data.discount) / 100 + update && item.admissionFee == 0
                  ? 0
                  : item.admissionFee
                : '',
          },
        };
        const noOfSessions = { target: { value: selectedSessionFee.session } };
        const sessionPriceId = { target: { value: selectedSessionFee.id } };
        const currencyType = { target: { value: currecyType } };
        const disamt = {
          target: {
            value:
              update && item.admissionFee !== 0
                ? parseFloat(item.discountedAmount) + parseFloat(item.admissionFee)
                : item.discountedAmount,
          },
        };
        const clearSubject = {
          target: {
            value: [
              {
                subjectId: -1,
                amountInr:
                  currecyType == 1
                    ? selectedSessionFee.price
                    : currecyType == 2
                    ? selectedSessionFee.priceAed * CART_AED_TO_INR_VALUE
                    : currecyType == 3
                    ? selectedSessionFee.convertedInr
                    : '',
                amountAed: currecyType == 2 ? selectedSessionFee.priceAed : '',
                inrForAed: currecyType == 2 ? CART_AED_TO_INR_VALUE : '',
              },
            ],
          },
        };
        if (data) {
          handleInputChange(clearSubject, item.id, 'subjects');
          handleInputChange(disamt, item.id, 'discountedAmount');
          handleInputChange(noOfSessions, item.id, 'noOfSessions');
          handleInputChange(mrp, item.id, 'MRP');
          handleInputChange(paidamt, item.id, 'paidAmt');
          handleInputChange(courseOptionId, item.id, 'selectedOption');
          handleInputChange(
            data.discount == 0 && !update ? disZero : data.discount == 0 && update ? disUpdate : dis,
            item.id,
            'discount'
          );
          handleInputChange(sessionPriceId, item.id, 'priceId');
          handleInputChange(currencyType, item.id, 'selectedCurrency');
          enqueueSnackbar('Option added Successfully...!', {
            variant: 'success',
          });
          setOpen(false);
        }
      }
    }
  };

  const rowRefs = useRef({});
  useEffect(() => {
    if (selected && rowRefs.current[selected]) {
      setTimeout(() => {
        rowRefs.current[selected]?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }, 100);
    }
  }, [selected]);
  return (
    <Box>
      {optionsLoading ? null : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            size="small"
            sx={{
              background: 'linear-gradient(to right, #702dff, black, black)',
              color: 'white',
              borderRadius: 3,
            }}
            onClick={() => {
              clearSetSelectedSessionFee();
            }}
          >
            <Icon icon="lets-icons:back" width="24" height="24" /> Back
          </Button>
        </Box>
      )}
      {selectedSessionFee ? (
        <MotionWrapper delay={0.5} directions={'top'}>
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 1 }}>
            <Stack direction={'row'} spacing={1}>
              <Chip size="small" variant="outlined" color="primary" label={`Session : ${selectedSessionFee.session}`} />
              <Chip size="small" variant="outlined" color="primary" label={`Price INR : ${selectedSessionFee.price}`} />
              <Chip
                size="small"
                variant="outlined"
                color="primary"
                label={`Price AED : ${selectedSessionFee.priceAed}`}
              />
              {currecyType == 2 ? <DicoutedAedInr /> : null}
            </Stack>
          </Box>
        </MotionWrapper>
      ) : null}
      <Box sx={{ width: 200, p: 1 }}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Currency Type</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={currecyType}
            label="Currency Type"
            onChange={handleChange}
          >
            <MenuItem value={1}>INR</MenuItem>
            <MenuItem value={2}>AED</MenuItem>
            <MenuItem value={3}>AED INR</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center',
          p: 1,
        }}
      >
        <MotionWrapper delay={0.5} directions={'top'}>
          <TableContainer
            sx={{
              backgroundColor: optionsLoading ? 'white' : 'grey.200',
            }}
            component={Paper}
          >
            {optionsLoading ? (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                  minHeight: '300px',
                }}
              >
                <Loader3D />
              </Box>
            ) : (
              <>
                {courseFeeOption?.length == 0 ? (
                  <NoDataFound />
                ) : (
                  <Box sx={{ maxHeight: '45vh', overflowY: 'auto' }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead
                        sx={{
                          position: 'sticky',
                          top: 0,
                          backgroundColor: 'white',
                          zIndex: 1,
                        }}
                      >
                        <TableRow>
                          <TableCell key={'Action'}>Action</TableCell>
                          {tblHead.map((item) => (
                            <>
                              {item.keyName === 'id' ? null : <TableCell key={item.keyName}>{item.keyName}</TableCell>}
                            </>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {courseFeeOption?.map((row) => {
                          const termKeys = Object.keys(row).filter((key) => key.startsWith('term'));

                          return (
                            <TableRow
                              ref={(el) => (rowRefs.current[row.id] = el)}
                              key={row.id}
                              sx={{
                                '&:last-child td, &:last-child th': {
                                  border: 0,
                                },
                                background: selected === row.id ? '#702dff' : 'inherit',
                                '& td, & th': {
                                  color: selected === row.id ? 'white' : 'inherit',
                                },
                              }}
                            >
                              <TableCell key={'Action'}>
                                <Checkbox
                                  checked={selected === row.id}
                                  onChange={(e) => handleClick(e, row)}
                                  inputProps={{ 'aria-label': 'controlled' }}
                                  sx={{
                                    color: 'black',
                                    '&.Mui-checked': {
                                      color: 'white',
                                      backgroundColor: 'black',
                                      borderRadius: '50%',
                                    },
                                    '&.Mui-checked svg': {
                                      color: 'white',
                                    },
                                  }}
                                />
                              </TableCell>
                              {/* <TableCell component="th" scope="row">
                                {row.id}
                              </TableCell> */}
                              <TableCell align="left">{row.discount}%</TableCell>
                              {termKeys.map((key) => (
                                <TableCell key={key} align="left">
                                  {row[key]}
                                </TableCell>
                              ))}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </Box>
                )}
              </>
            )}
          </TableContainer>
        </MotionWrapper>
      </Box>

      {selected ? (
        <MotionWrapper delay={0.5} directions={'top'}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              pt: 2,
            }}
          >
            <Button
              onClick={handleConfirm}
              sx={{
                background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
                color: 'white',
                borderRadius: 3,
              }}
            >
              <Icon icon="line-md:confirm-circle" width="24" height="24" />
              Confirm Option
            </Button>
          </Box>
        </MotionWrapper>
      ) : null}
    </Box>
  );
};

export default Options;
